import Vue from 'vue'
import store from '@/store'

Vue.filter('code', (code = '', category) => {
  const rVal = store.getters['proxy/code/getCategory'](category)
  if (rVal) {
    return rVal.find((r) => r.code === code).name
  }
  return ''
  //   return rVal ? code : rVal.find(r => r.code === code).name
})
